import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export type UseSortableRowProps = {
  rowId: string | number;
  isSortable?: boolean;
};
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
export const useSortableRow = t0 => {
  const $ = _c(15);
  const {
    rowId,
    isSortable
  } = t0;
  const t1 = !isSortable;
  let t2;
  if ($[0] !== rowId || $[1] !== t1) {
    t2 = {
      id: rowId,
      animateLayoutChanges,
      disabled: t1
    };
    $[0] = rowId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable(t2);
  const t3 = isSortable ? attributes : undefined;
  const t4 = isSortable ? listeners : undefined;
  let t5;
  if ($[3] !== transform) {
    t5 = CSS.Translate.toString(transform);
    $[3] = transform;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isDragging ? 0.5 : undefined;
  let t7;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== transition) {
    t7 = {
      transform: t5,
      transition,
      opacity: t6
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = transition;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isDragging || $[10] !== setNodeRef || $[11] !== t3 || $[12] !== t4 || $[13] !== t7) {
    t8 = {
      setNodeRef,
      isDragging,
      attributes: t3,
      listeners: t4,
      style: t7
    };
    $[9] = isDragging;
    $[10] = setNodeRef;
    $[11] = t3;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};